import React, { Component } from 'react';
import './registration.css';
import { AppCollapsible } from '../AppCollapsible';
import { registrationTypes } from '../../../config/types';
import { countries } from '../../../config/countries';
import { regTitles } from '../../../config/reg-titles';
import { connect } from 'react-redux';
import { setRegTypeId } from '../../../redux/actions/regTypeId';
import { editInputWithProps } from '../../../redux/actions/inputWithProps';
import { AppSelect } from '../AppSelect';
import { AppInputWrapper } from '../AppInputWrapper';

class Registration extends Component {

    constructor(props) {
        super(props);

        this.registrationTypes = registrationTypes.map(el => ({ label: el.label, value: el.id, legacyValue: el.value }) );
        this.countries = this.mapSelectItems(countries);
        this.regTitles = this.mapSelectItems(regTitles);
    }

    state = {
        label: this.props.initialValues.label || '',
        required: this.props.initialValues.isRequired || false,
        placeholder: this.props.initialValues.placeholder || 'Type...',
        selectedType: null,
        inputValue: '',
        requiredError: this.props.initialValues.isRequired || false,
    };

    updateInputPropsInStore = () => {
        const inputProps = {
            type: this.props.initialValues.type,
            subType: this.state.selectedType ? this.state.selectedType.value : null,
        };

        if (inputProps.subType) {
            inputProps['label'] = this.state.label;
            inputProps['isRequired'] = this.state.required;
            inputProps['_hasValidationErrors'] = this.state.requiredError;
            inputProps['_value'] = this.state.inputValue;

            if (
                inputProps.subType !== 8 &&
                inputProps.subType !== 1
            ) {
                inputProps['placeholder'] = this.state.placeholder;
            }
        }

        this.props.editInputWithProps(this.props.initialValues.id, inputProps);
    };

    componentDidMount() {
        setTimeout(_ => {
            this.updateInputPropsInStore();
        }, 500);

        if (this.props.initialValues.subType) {
            const key = typeof this.props.initialValues.subType === 'string' ? 'legacyValue' : 'value';
            const val = this.registrationTypes.find(el => el[key] === this.props.initialValues.subType);
            if (val) {
                this.setType(val, this.props.initialValues.label);
            }
        }
    };

    componentDidUpdate() {
        this.updateInputPropsInStore();
    };

    mapSelectItems = (list) => {
        return list.map(el => ({ label: el, value: el }) );
    };

    chooseType = (e) => {
        const selectedId = Number(e.value);
        const typeIsChosen = Object.values(this.props.regTypeId).find(id => id === selectedId);
        if (typeIsChosen !== undefined) {
            alert('This registration type already added');
        } else {
            const val = this.registrationTypes.find(el => el.value === selectedId);
            this.setType(val);
        }
    };

    setType = (val, label) => {
        this.props.setRegTypeId({ key: this.props.initialValues.id, id: val.value });
        this.setState({ selectedType: val, label: label || val.label });
    }

    setLabel = (e) => {
        this.setState({ label: e.target.value });
    };

    setRequired = (e) => {
        this.setState({ required: e.target.checked });
    };

    setPlaceholder = (e) => {
        this.setState({ placeholder: e.target.value });
    };

    setValue = (value) => {
        this.setState({
            inputValue: value,
            requiredError: this.state.required ? !value : false
        });
    };

    renderInput = () => (
        <label className="reg-type-label">
            <div className="default-input-wrapper">
                <input
                    value={this.state.inputValue}
                    onChange={(e) => this.setValue(e.target.value)}
                    name={this.state.selectedType.value}
                    className="default-registration-input"
                    type="text"
                    placeholder={this.state.placeholder}
                />
            </div>
        </label>
    );

    renderCountriesSelect = () => (
        <label className="reg-type-label">
            <AppSelect
                color={this.props.color}
                value={this.state.inputValue}
                onChange={(e) => this.setValue(e.value)}
                className="reg-countries_select"
                placeholder="Country"
                options={this.countries}
            />
        </label>
    );

    renderTitleSelect = () => (
        <AppSelect
            color={this.props.color}
            value={this.state.inputValue}
            onChange={(e) => this.setValue(e.value)}
            className="reg-titles-select"
            placeholder="Title"
            options={this.regTitles}
        />
    );

    render() {
        const { textColor, isResultInput } = this.props;
        const { required, selectedType, placeholder, label, requiredError } = this.state;
        return (
            <>
                {
                    !isResultInput &&
                    <AppSelect
                        className="reg-types_select"
                        placeholder="Type"
                        options={this.registrationTypes}
                        onChange={this.chooseType}
                        value={selectedType}
                    />
                }

                {
                    selectedType &&
                    <AppInputWrapper
                        label={label}
                        color={textColor}
                        required={required}
                        requiredError={requiredError}
                    >
                        {
                            selectedType.value === 1 ?

                                this.renderTitleSelect(textColor) :

                            selectedType.value === 8 ?

                                this.renderCountriesSelect() :

                                this.renderInput()
                        }
                    </AppInputWrapper>
                }
                {
                    selectedType && !isResultInput &&
                    <AppCollapsible>
                        <div className="settings-container">
                            {
                                <>
                                    <label>
                                        <input
                                            checked={required}
                                            className="password-checkbox_value"
                                            type="checkbox"
                                            onChange={this.setRequired}
                                        />
                                        <span className="password-checkbox_option">Required</span>
                                    </label>

                                    <label>
                                        <input onChange={this.setLabel} value={label} type="text"/>
                                        Label
                                    </label>

                                    {
                                        selectedType.value !== 8 &&
                                        selectedType.value !== 1 &&
                                        <label>
                                            <input
                                                onChange={this.setPlaceholder}
                                                value={placeholder}
                                                type="text"
                                            />
                                            Placeholder
                                        </label>
                                    }
                                </>

                            }
                        </div>
                    </AppCollapsible>
                }
            </>
        )
    }
}

export default connect(
    state => ({
        regTypeId: state.regTypeId,
    }),
    {
        setRegTypeId,
        editInputWithProps
    }
)(Registration);
